<div id="ficha-productos-funds" class="container mt-4 mb-5">
  <div class="row">
    <div class="swiper swiperProductosFunds">
      <div class="swiper-wrapper">
        @for (ficha of fichaData; track ficha) {
          <div class="col-3 pointer swiper-slide">
            <a routerLink="{{ficha.btnLink}}" class="card shadow-8 position-relative">
              <div class="img-container text-center">
                <img src="{{ficha.imgSrc}}" class="img-fluid mh-330" alt="producto-img">
              </div>
              <div class="card-img-overlay">
                <h4 class="text-center" [innerHTML]="ficha.title"></h4>
              </div>
              <p [innerHTML]="ficha.subtitle"></p>
            </a>
          </div>
        }
      </div>
      <div id="pagination" class="mt-5 d-xl-none">
        <div class="swiper-pagination swiper-pagination-productos-funds">
        </div>
      </div>
    </div>
  </div>
</div>